// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"1896":"2dfe08ec0f17c2b7","5443":"93b2e2af59bf3304","6350":"f47384eec0780103","7482":"db2d8fa0470e3bac"}[chunkId] + ".js";
};